import { Link } from 'react-router';
import { ClockIcon } from 'lucide-react';

import { AuthShell, AuthHeading } from 'src/components/Layout';
import { Button } from '@/components/ui/button';

function SessionExpiredPage() {
  return (
    <AuthShell>
      <div className="size-14 rounded-xl flex items-center justify-center shrink-0 text-secondary-foreground bg-primary mb-4 ">
        <ClockIcon className="size-7" />
      </div>
      <AuthHeading
        title="You've been signed out"
        description="Your session expired after a period of inactivity. Sign in again to continue."
      />
      <Button asChild className="w-full" size="lg">
        <Link to="/login">Sign in</Link>
      </Button>
    </AuthShell>
  );
}

export default SessionExpiredPage;
